export const SCANDPHOTOS_GET_PHOTOGRAPHERBOOKING_SUCCESS =
    'SCANDPHOTOS_GET_PHOTOGRAPHERBOOKING_SUCCESS';
export const SCANDPHOTOS_UPDATE_PHOTOGRAPHERBOOKING_SUCCESS =
    'SCANDPHOTOS_UPDATE_PHOTOGRAPHERBOOKING_SUCCESS';
export const SCANDPHOTOS_GET_ORDERINFO_SUCCESS = 'SCANDPHOTOS_GET_ORDERINFO_SUCCESS';
